import { defineAsyncComponent } from "vue";

const StripePayment = defineAsyncComponent(() =>
  import("@/components/StripePayment/StripePayment.vue")
);

export default {
  install: (app) => {
    // 全局注册组件
    app.component("StripePayment", StripePayment);

    // 添加全局方法
    app.config.globalProperties.$stripe = {
      loadScript: () => {
        return new Promise((resolve) => {
          if (window.Stripe) return resolve();

          const script = document.createElement("script");
          script.src = "https://js.stripe.com/v3/";
          script.async = true;
          script.onload = resolve;
          document.head.appendChild(script);
        });
      }
    };
  }
};
